"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRowFeaturedCell = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const layout_1 = require("../layout");
const styled_1 = __importDefault(require("../../styles/styled"));
const attribute_1 = require("../../util/attribute");
const Headline = styled_1.default.div `
    font-size: ${props => props.theme.text.size[props.size]};
    font-family: ${props => props.theme.text.headingFontFamily};
    font-weight: 500;
    text-transform: none;
    word-break: break-word;
    color: ${props => props.theme.text.color[props.color]};
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: normal;
`;
const Subhead = styled_1.default.div `
    font-family: ${props => props.theme.text.bodyFontFamily};
    font-size: 1rem;
    font-weight: 400;
    color: ${props => props.theme.text.color[props.color]};
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: normal;
`;
const ListRowFeaturedCell = (_a) => {
    var { headline, subHeadline, subHeadlineColor = 'grey90', headlineColor = 'grey90', headlineSize = 'mediumLarge', testid = 'listrow-featured-cell', monochrome } = _a, columnProps = __rest(_a, ["headline", "subHeadline", "subHeadlineColor", "headlineColor", "headlineSize", "testid", "monochrome"]);
    const testId = (0, attribute_1.createTestIdFunc)(testid);
    return ((0, jsx_runtime_1.jsxs)(layout_1.Column, Object.assign({}, columnProps, { children: [(0, jsx_runtime_1.jsx)(layout_1.Row, Object.assign({ "data-testid": testId(), marginBottom: '5px' }, { children: (0, jsx_runtime_1.jsx)(Headline, Object.assign({ "data-testid": testId('headline'), color: headlineColor, size: headlineSize }, { children: headline })) })), (0, jsx_runtime_1.jsx)(Subhead, Object.assign({ "data-testid": testId('subhead'), color: subHeadlineColor, monochrome: monochrome }, { children: subHeadline }))] })));
};
exports.ListRowFeaturedCell = ListRowFeaturedCell;
//# sourceMappingURL=featured_cell.js.map